import { ChartDataTabs } from './modules/Tabs';
import { useParams } from 'react-router-dom';

export const CycleChartData = () => {
  const {
    // clientId,
    // contractId,
    // screenId,
    id,
  } = useParams();

  return <ChartDataTabs cycleId={id} />;
};
